import type { TradableAssetsContent } from "../types";

export const tradableAssets: TradableAssetsContent = {
  meta: {
    // [de-review] SERP-visible; inside the 60/160 caps.
    title: "Handelbare Assets | 300+ Instrumente | Flex Fund",
    description:
      "Handle über 300 Instrumente — Forex, Indizes, Metalle, Krypto, Energie, US-Aktien — auf einem Flex Fund MetaTrader-5-Prop-Firm-Konto.",
  },
  hero: {
    line1: "Forex. Indizes.",
    line2: "Metalle. Krypto.",
    highlight: "Ein Konto.",
    // [de-review] Claims spread parity between evaluation and funded accounts.
    lede: "Jedes Instrument, das unsere Liquiditätsanbieter bieten. Dieselben Spreads in der Evaluation wie im finanzierten Konto.",
  },
  counts: {
    forexPairs: "Forex-Paare",
    commodities: "Rohstoffe",
    crypto: "Krypto",
    indicesStock: "Indizes & Aktien",
  },
  chips: {
    ALL: "Alle",
    FOREX: "Forex",
    COMMODITIES: "Rohstoffe",
    CRYPTO: "Krypto",
    INDICES_STOCK: "Indizes & Aktien",
  },
  table: { symbol: "Symbol", category: "Kategorie" },
  emptyState: "Keine Instrumente entsprechen dem aktuellen Filter.",
  // [de-review] Repeats the spread-parity claim.
  footnote: "Dieselben Raw Spreads in der Evaluation wie im finanzierten Konto.",
  categories: {
    FOREX: "FOREX",
    INDICES: "INDIZES",
    METALS: "METALLE",
    CRYPTO: "KRYPTO",
    ENERGIES: "ENERGIE",
    STOCKS: "AKTIEN",
  },
};
